import { render, staticRenderFns } from "./AssignScienceSector.vue?vue&type=template&id=53b55b08&"
import script from "./AssignScienceSector.vue?vue&type=script&lang=js&"
export * from "./AssignScienceSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports